import React, { useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useFormContext } from "react-hook-form";

const DateTimePicker = ({ label, className = "", name }) => {
  // const [startDate, setStartDate] = useState(selectedDate || new Date());

  // const handleChange = (date) => {
  //   setStartDate(date);
  //   handleDateChange(date);
  // };
  const { control, formState } = useFormContext();

  return (
    <Controller name={name} control={control} render={({ field }) => (
      <div className="flex flex-col">
        {label && <label className="text-sm font-semibold text-[#0F172A]">{label}</label>}
        <DatePicker
          selected={field?.value}
          onChange={field.onChange}
          showTimeSelect
          dateFormat="dd-MM-yyyy hh:mm aa"
          className={`py-3 px-3 border text-[#808080] border-borderColor rounded-xl w-full mt-4 ${className}`}
        />
        {formState.errors?.[name]?.message && (
          <div className="flex text-red-500 w-full text-sm justify-start px-3 mt-2">
            <span className="text-left">{formState.errors?.[name]?.message}</span>
          </div>
        )}
      </div>
    )} />


  );
};

export default DateTimePicker;
